// =========================================================
// BLOC CONTACT (pré-footer) — parallax HORIZONTAL de la photo de fond au
// scroll (même recette que la photo des services : xPercent ±8, débord
// latéral -8%/116% posé dans le SCSS). L'overlay et le dégradé ne bougent pas.
// ⚠️ Piège de test connu : le bloc est en BAS de page — une fois arrivé en
// butée de scroll, le parallax semble « gelé » alors qu'il fonctionne.
// =========================================================
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('.km-prefooter').forEach((section) => {
        const img = section.querySelector('.km-prefooter__bg img');
        if (!img) return;
        gsap.set(img, {xPercent: -8});
        gsap.to(img, {
            xPercent: 8,
            ease: 'none',
            scrollTrigger: {
                trigger: section,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
            },
        });
    });

});
